import { OrderConstants } from '../_constants';

//-- get the list of banners
export function getAllOrders(state = {}, action) {
  switch (action.type) {
    case OrderConstants.GET_ALL_ORDER_REQUEST:
      return { orderList: false };

    case OrderConstants.GET_ALL_ORDER_SUCCESS:
      return { orderList: action.successAction };

    case OrderConstants.GET_ALL_ORDER_FAILURE:
      return { orderList: false, };

    case OrderConstants.ORDER_SEARCH_REQUEST:
      return { orderList: action.successAction.data };

    default:
      return state
  }
}

//-- get the list of banners
export function markOrder(state = {}, action) {
  switch (action.type) {
    case OrderConstants.MARK_ORDER_REQUEST:
      return { deleteResponse: false };

    case OrderConstants.MARK_ORDER_SUCCESS:
      return { deleteResponse: action.successAction };

    case OrderConstants.MARK_ORDER_FAILURE:
      return { deleteResponse: false, };

    default:
      return state
  }
}

//-- get the list of banners
export function markOrderAccepted(state = {}, action) {
  switch (action.type) {
    case OrderConstants.MARK_ORDER_ACCEPTED_REQUEST:
      return { accepted: false };

    case OrderConstants.MARK_ORDER_ACCEPTED_SUCCESS:
      return { accepted: action.successAction };

    case OrderConstants.MARK_ORDER_ACCEPTED_FAILURE:
      return { accepted: false, };

    default:
      return state
  }
} 